import { Loader } from 'lucide-react';

export const LoadingState = () => {
  return (
    <div className="flex flex-col items-center justify-center h-screen gap-4 bg-galaxia">
      <Loader size={48} className="animate-spin-slow text-primary" />
      <p className="text-muted-foreground text-base">Carregando dados do CRM...</p>
    </div>
  );
};
